import { Controller } from "@hotwired/stimulus"

// Observes the claim status indicator (Turbo-replaced when agent finishes)
// and syncs the "missing info" red border on the claim details card.
export default class extends Controller {
  static targets = ["status", "details", "detailsDivider"]

  // Called by Stimulus whenever a status target connects (including after Turbo Stream replace)
  statusTargetConnected() {
    this.syncBorder()
  }

  syncBorder() {
    if (!this.hasStatusTarget || !this.hasDetailsTarget) return

    const isMissingInfo = this.statusTarget.dataset.state === "missing_info"

    if (isMissingInfo) {
      this.detailsTarget.classList.remove("border-support-light-300")
      this.detailsTarget.classList.add("border-alert-red-500")
      if (this.hasDetailsDividerTarget) {
        this.detailsDividerTarget.classList.remove("border-support-light-300")
        this.detailsDividerTarget.classList.add("border-alert-red-500")
      }
    } else {
      this.detailsTarget.classList.remove("border-alert-red-500")
      this.detailsTarget.classList.add("border-support-light-300")
      if (this.hasDetailsDividerTarget) {
        this.detailsDividerTarget.classList.remove("border-alert-red-500")
        this.detailsDividerTarget.classList.add("border-support-light-300")
      }
    }
  }
}
